import React, { useEffect } from "react";
import { Drawer, Typography, Button, Form, Input, message } from "antd";
import { UPDATE_NOTIFICATION } from "./requests";
import { useMutation } from "@apollo/client";
import { Container } from "../../../elements";
import { notificationTypes } from "../../../../../types";

const { Title, Text } = Typography;

type EditNotificationProps = {
  showModal: boolean;
  setShowModal: (value: boolean) => void;
  selectedNotification: typeof notificationTypes.notification | null;
  setSelectedNotification: (value: typeof notificationTypes.notification | null) => void;
  refetch: () => Promise<any>;
};

type FormValues = {
  title?: string;
  description?: string;
};

const EditNotification: React.FC<EditNotificationProps> = ({
  showModal,
  setShowModal,
  selectedNotification,
  setSelectedNotification,
  refetch,
}) => {
  const [form] = Form.useForm<FormValues>();
  const [updateNotificationMutation] = useMutation(UPDATE_NOTIFICATION);

  useEffect(() => {
    if (showModal && selectedNotification) {
      form.setFieldsValue({
        title: selectedNotification.title,
        description: selectedNotification.description,
      });
    } else {
      form.resetFields();
    }
  }, [showModal, selectedNotification, form]);

  const onClose = () => {
    setShowModal(false);
    setSelectedNotification(null);
  };

  const onFinish = async (values: FormValues) => {
    if (!selectedNotification) return;

    try {
      const payload = {
        variables: {
          id: selectedNotification.id,
          notification: {
            title: values.title || selectedNotification.title,
            description: values.description || selectedNotification.description,
          },
        },
      };
      await updateNotificationMutation(payload);
      await refetch();
      message.success("Se editó con éxito!");
    } catch (err) {
      console.error(err);
      message.error("Error al editar");
    } finally {
      onClose();
    }
  };

  return (
    <Container>
      <Drawer
        open={showModal}
        onClose={onClose}
        title={<Title level={3}>Editar Notificación</Title>}
        width={"60%"}
      >
        <Form form={form} name="notification" onFinish={onFinish}>
          <div>
            <Text style={{ fontWeight: "800",
              marginRight: 10,
              fontSize: 14 }}>
              Nombre de la Notificación
            </Text>
            <Form.Item name="title">
              <Input placeholder="Nombre" />
            </Form.Item>
          </div>
          <div>
            <Text style={{ fontWeight: "800",
              marginRight: 10,
              fontSize: 14 }}>
              Descripción
            </Text>
            <Form.Item name="description">
              <Input placeholder="Descripción" />
            </Form.Item>
          </div>
          <div style={{ marginTop: 20 }}>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Editar Notificación
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Drawer>
    </Container>
  );
};

export default EditNotification;
